import React from 'react';
import Module from './Module';
import { FormControl, Input, RichEditor } from 'components';

const RandomText = (props) => {
	const { context } = props;
	const { validationErrors, state } = context;

	return (
		<Module name="Random Text" {...props}>
			<FormControl
				label="Text :"
				marginBottom="mb-0"
				error={validationErrors['settings.modules.random_text.text']}
			>
				<RichEditor
					placeholder="Enter your sold here!"
					BindToContext={[context, 'settings.modules.random_text.text']}
					hasError={!!validationErrors['settings.modules.random_text.text']}
				/>
			</FormControl>
		</Module>
	);
};

export default RandomText;
